var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrations = function SvgIntegrations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "m8.37 6.85 7.03 4.1.8-1.38-7.03-4.1ZM9.17 18.53l7.03-4.1-.8-1.38-7.03 4.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M6 2a3 3 0 1 1 0 6 3 3 0 1 1 0-6m0 1.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 1 0 0-2.8M6 16a3 3 0 1 1 0 6 3 3 0 1 1 0-6m0 1.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 1 0 0-2.8M18 9a3 3 0 1 1 0 6 3 3 0 1 1 0-6m0 1.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 1 0 0-2.8",
    clipRule: "evenodd"
  })));
};
export default SvgIntegrations;